import { Info, P, Title } from '@Components/TermsAndConditions/TermsAndConditions.styled';
import React from 'react';
type Props = {};

export default React.memo(function Privacy({}: Props) {
  return (
    <div dir="auto">
      <Title>سياسة الخصوصية:</Title>
      <P>
        أهلا بكم في يوربارتس, هدفنا منذ الإنشاء هو التيسير والتسهيل على جميع عملائنا في عملية شراء مستلزماته وكل ما
        يحتاجه من قطع غيار واكسسورات وكل ما يخص السيارات، لذلك تقع على عاتقنا مهمة حماية معلوماتك الشخصية، ويتم توضيح
        هذه السياسة وكيفية استخدام معلوماتك الشخصية عبر موقع www.yourparts.com والتطبيق المتوفر على الأجهزة الذكية
        أيفون، أندرويد(المشار إليها جميعاً في الموقع). علماً بأن سياسة الخصوصية هذه لا تنطبق على مواقع شركائنا في العمل،
        أو أي أطراف أخرى، وحتى إن تم الإشارة إليهم على الموقع. لذا ننصحك بمراجعة سياسة الخصوصية العائدة للأطراف الأخرى
        التي تود التعامل معها. عند استخدامك للخدمات المتوفرة على الموقع أو تطبيقات الموبايل، سيتم طلب تقديم بعض
        المعلومات مثل اسمك، عناوين الاتصال، معلومات المعاملة معلومات التصفح بالموقع أو التطبيق. ويتم تخزين هذه المعلومات
        والاحتفاظ بها على أجهزة الكمبيوتر أو
      </P>
      <Title>تسجيل العضوية</Title>
      <Info>
        يحظر القاصرين اللذين تقل أعمارهم عن 18 عاما التسجيل كمستخدمين لهذا الموقع الالكترونى ولا يسمح لهم بممارسة أو
        استخدام موقع الويب
      </Info>
      <Info>ولا يحق لك فتح حسابين في نفس الوقت دون اخبار اداره الموقع والسماح لك بذلك</Info>
      <Info>
        كما ان العميل هو المسؤول الأول والأخير عن من يسمح لهم بالشراء من على حسابه كما أن العميل هو المسول عن الاحتفاظ
        بسريه معلوماتك الشخصيه.
      </Info>
      <Info>العميل بموجب هذا الحساب يكون موافق ضمنا على هذه الشروط والأحكام ملزما بها أثناء استخدام الموقع.</Info>
      <Info>
        لا بد من تسجيل العضوية على الموقع وذلك لان لم تتم أي عملية شراء على الموقع بدون عضوية ويكون المشترى مسئول
        مسئوليه كاملة عن المعلومات الخاصة التي يزودنا بها ولابد من أن تكون معلومات صحيحه وحديثه كاسم المستخدم والبريد
        الالكترونى ورقم الهاتف وكلمه المرور الخاصة به وفي حاله عدم الالتزام بدقه المعلومات وصحتها يحق لنا إلغاء العضوية
        من على الموقع.
      </Info>
      <Info>كما هو جدير بالذكر أن يكون المشترى هو المسئول عن من يسمح لهم بالشراء من على حسابه .</Info>
      <Title>تعديلات على اتفاقية المستخدم واليه العمل على الموقع</Title>
      <Info>
        يوربارتس لها الحق الأول والأخير في إجراء أي تعديلات في الشروط والأحكام في الوقت التي تراه مناسبا دون الرجوع إلى
        العميل أو المستخدم وتكون نافذة فور نشر على الموقع والموقع غير مسئول عن عدم علمك بأي تغييرات فمن الملزم على
        المستخدم أو العميل مراجعه الشروط والأحكام باستمرار لتبقى على علم دائم بأي تغييرات.
      </Info>
    </div>
  );
});
